import { Color } from 'csstype';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { DarkBorder, GreyText } from '../Components/CommonStyles';
import { LoginState, PlayerData } from '../Models/ApplicationInterfaces';
// import {device} from '../Models/mediaDevices';
import { networkManager } from '../NetworkManager/NetworkManager';
import { Avatar } from './../Components/Avatar';
import { playerColorList, playerIconList } from './../utility/PlayerDataGenerator';

interface Props{
    playerData: PlayerData;
    changeState: (_:LoginState) => void;
    setLoading: (_:boolean) => void;
    setPlayerData: (_:PlayerData) => void;
}
interface State{
    code:string,
    nameError:string,
    codeError:string,

    menuOpen: boolean;
}
export class Login extends React.Component<Props,State>{
    
    public state = {name:"", code:"",nameError:"", codeError:"", menuOpen: true};
    private specialIconMap: Record<string, number> = {
        "Halberd": 4,
        "ShasO": 5,
    };
    public render(){
        return (
            <LoginWrapper>
                <Title src="LoginPage/HalfTitle.png"/>
                <LoginBox>
                    <LoginLabel>User Login</LoginLabel>
                    <CharacterCustomiser>
                        <IconSelector src="LoginPage/Arrow.png" onClick={this.incrementPlayerIcon} isOpen={this.state.menuOpen} top={true}/>
                        <IconSelector src="LoginPage/Arrow.png" onClick={this.decrementPlayerIcon} isOpen={this.state.menuOpen} top={false}/>
                        <AvatarContainer onClick={this.toggleMenu}>
                            <Avatar icon={this.props.playerData.icon} color={this.props.playerData.color}/>
                        </AvatarContainer>
                        {playerColorList.map((color: Color, i: number) => <ColorSelect isOpen={this.state.menuOpen} key={i} color={color} x={i % 2} y={Math.floor(i / 2)} selected={this.props.playerData.color === color} onClick={this.changeColor(color)}/>)}
                    </CharacterCustomiser>
                    
                    <Field>
                        <LabelText>Name:</LabelText>
                        <TextBox type="text" value={this.props.playerData.name} placeholder={this.props.playerData.name} onChange={this.changeName}  />
                    </Field>
                    <Field>
                        <LabelText>Code:</LabelText>
                        <TextBox type="text" value={this.state.code} placeholder="CY8T" onChange={this.changeCode}/>
                    </Field>
                    {
                        this.state.nameError === '' && this.state.codeError === '' ?
                            <JoinButton onClick={this.joinGame}>Join</JoinButton>
                        :
                            <ErrorSign> {this.state.nameError || this.state.codeError } </ErrorSign>
                    }
                </LoginBox>
            </LoginWrapper>)
    }
    private toggleMenu = () => this.setState(old => ({menuOpen: !old.menuOpen}));
    // You are welcome for some of that functional programming XD (note if you havn't yet seen the spread operator (...) it basically copies all they key values into the object)
    private changePlayerData = (data:Partial<PlayerData>) => this.props.setPlayerData({...this.props.playerData, ...data});
    private changeName = (event: React.ChangeEvent<HTMLInputElement>) => {
        let extraData = {};
        if(this.specialIconMap[event.currentTarget.value] != null) {
            extraData = {color:"#FFFFFF", icon: this.specialIconMap[event.currentTarget.value]};
            this.setState({menuOpen:false});
        }
        this.changePlayerData({name:event.currentTarget.value, ...extraData});
        this.setState({nameError:''});
    }
    private changeColor = (color: Color) => () => this.changePlayerData({color});
    private changePlayerIcon = (step: number) => () => this.changePlayerData({icon: (this.props.playerData.icon + step +  (playerIconList.length - 2)) % (playerIconList.length - 2)});
    
    // tslint:disable-next-line: member-ordering
    private incrementPlayerIcon = this.changePlayerIcon(1);
    // tslint:disable-next-line: member-ordering
    private decrementPlayerIcon = this.changePlayerIcon(-1);

    private changeCode = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({code:event.currentTarget.value, codeError: ''})
    private joinGame = async () => {
        // Validate Playername
        if(
            !this.props.playerData.name.match(/^[a-zA-Z0-9_ ]*$/) ||
            this.props.playerData.name.length > 10
        ) {
            this.setState({nameError: "Invalid name" })
            this.props.setLoading(false);
            return;
        }
        
        if(this.state.code === "0000") {
            (global as any).debug = true;
            this.props.setLoading(true);
            this.props.changeState(LoginState.inLobby);
            return;
        }
        this.props.setLoading(true);
        const gameData = await networkManager.getServerString(this.state.code.toUpperCase());
        
        console.log(gameData);
        
        if(gameData.status === 200) {
            console.log(gameData);
            await networkManager.connectToServer(gameData.connectionString , this.state.code.toUpperCase(), this.props.playerData.name, this.props.playerData.icon, this.props.playerData.color.slice(1));
            // this.props.changeState(GameState.inLobby);
            // this.props.setLoading(false);
        } else {
            this.setState({codeError: gameData.status === 404 ? "No Game": gameData.status === 401 ? "Game Full": gameData.status === 403 ? "Game Locked" : "Error" })
            this.props.setLoading(false);
        }
        
        
    }
}

const CharacterCustomiser = styled.div`
    width:100%;
    display: flex;
    flex-direction:row;
    justify-content:center;
    position:relative;
`;

const AvatarContainer = styled.div`
    height:28vmin;
    width:28vmin;
    border: #00A3FF solid 3px;
    border-radius: 10px;
    background-color: black;
    
`;
const IconSelector = styled.img<{isOpen: boolean, top: boolean}>`
    position: absolute;
    left: 16%;
    top: 7%;
    ${p => !p.top && css`
        top: 57%;
        transform: rotate(180deg);
    `};
    width: 9vmin;
    padding:1vmin;
    border: #00A3FF solid 3px;
    border-radius: 10px;
    background:black;
    transition: top 0.5s, left 0.5s, width 0.5s, height 0.5s;
    ${p => !p.isOpen && css`
        width:0;
        height:0;
        left: 49%;
        top: 50%;
    `}
`;
const ColorSelect = styled.div<{isOpen: boolean, x: number, y: number,color: Color, selected: boolean}>`
    width:9vmin;
    height: 9vmin;
    position:absolute;
    border-radius: 100%;
    box-sizing: border-box;
    transition: top 0.5s, right 0.5s, width 0.5s, height 0.5s;
    ${p => css`
        right: ${p.x === 0 ? 18 : 6}%;
        top: ${p.y * 35}%;
        background-color:${p.selected ? "black" : p.color};
        ${p.selected && `box-shadow:inset 0px 0px 0px 3px ${p.color};`}
    `}
    ${p => !p.isOpen && css`
        width:0;
        height:0;
        right: 49%;
        top: 50%;
    `}
`;

const JoinButton = styled(DarkBorder)`
    width: 68%;
    font-size: 8vh;
    margin: auto;
    max-height: 9vh;
    display: flex;
    justify-content: center;
    align-items: baseline;
    border-radius: 12px;
`;
const ErrorSign = styled.div`
    border: red solid 4px;
    background-color: #7E0303;
    color: red;
    width: 86%;
    font-size: 8vh;
    margin: auto;
    max-height: 9vh;
    display: flex;
    justify-content: center;
    align-items: baseline;
`;
const Field = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-evenly;
    align-items: center;
    margin: 10px 0;
`;

const TextBox = styled.input`
    border: #00A3FF solid 4px;
    font-size:4vh;
    color:white;
    background-color: black;
    max-width: 50%;
    padding: 10px;
    height:fit-content;
`;
const LoginWrapper = styled.div`
    z-index:4;
    display:flex;
    flex-direction:column;
    align-items:center;
    background-color:black;
    width:100%;
    height:100vh;
    font-family: Teko;

    @media (orientation:landscape) {
        height:0;
        width: 85%;
        margin:auto;
    }
`;
const Title = styled.img`
    max-width: 95%;
    min-width: 50%;
    margin-bottom:5vh;
    
    @media (orientation:landscape) {
        min-width:30%;
        width:30%;
    }
`;
const LoginLabel = styled(DarkBorder)`
    border-radius: 12px;
    height: 4vh;
    padding: 2%;
    
    font-size: 6vh;
    position: absolute;
    top: -27px;
    left: -4px;
    display: flex;
    align-items: center;
`;
const LoginBox = styled.div`
    max-width: 95%;
    min-width: 90%;
    
    display:flex;
    flex-direction:column;
    background-color:#1A1A1A;
    border: #00A3FF solid 4px;
    border-radius:12px;
    position:relative;
    padding: 6vh 0 3vh 0;
    @media (orientation:landscape) {
        max-width:100%;
        
        justify-content: center;
        flex-direction:row;
        flex-wrap:wrap;
    }
`;
const LabelText = styled(GreyText)`
    font-size:7vh;
    min-width: 26%;
`;


// WEBPACK FOOTER //
// ./src/Views/Login.tsx